import { Redirect, useSearch } from 'wouter';

/** The Dojo page. */
export const DOJO_PATH = '/admin/dojo';

/** The page's address before it became the Dojo. It only redirects and is not in the nav. */
export const LEGACY_TRAINING_LAB_PATH = '/agent-training-lab';

/** Sends the old address to the Dojo, keeping any query string. */
export function LegacyTrainingLabRedirect() {
  const search = useSearch();
  return <Redirect to={search ? `${DOJO_PATH}?${search}` : DOJO_PATH} replace />;
}
